export class TesteEmail {
  usu: number;
  host: string;
  porta: string;
  usuario: string;
  senha: string;
  ssl: boolean;
  tsl: boolean;
}
